import BaseService from '../base.service';

export class MessageService {
  static async messageListApi(params) {
    return BaseService.get('/web/message', params);
  }
  static async getMessageByIdApi(id) {
    return BaseService.get(`/web/message/${id}`);
  }
}
